import { createStore } from 'vuex';

import { storeGlobalConfig } from '@/services/vuex-global-config.js';

import actions from './actions';
import getters from './enquiry-form.getters.js';
import mutations from './enquiry-form.mutations.js';
import state from './enquiry-form.state.js';
import wishlist from './wishlist';

export const storeConfig = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default createStore({
  ...storeGlobalConfig,
  ...storeConfig,
  modules: {
    wishlist,
  },
});
